// /*
//  * Copyright (c) Secureroo PTY LTD 2022
//  */

// const addPagerToTables = function (tables, rowsPerPage = 10) {
//   tables =
//     typeof tables == "string" ? document.querySelectorAll(tables) : tables;

//   for (let table of tables) {
//     addPagerToTable(table, rowsPerPage);
//   }
// }

// const addPagerToTable = function (table, rowsPerPage = 10) {
//   let tBodyRows = getBodyRows(table);
//   let numPages = Math.ceil(tBodyRows.length / rowsPerPage);

//   table.querySelector("tfoot")?.remove();

//   let colCount = [].slice
//   .call(table.querySelector("tr").cells)
//   .reduce((a, b) => a + parseInt(b.colSpan), 0);

//   table
//   .createTFoot()
//   .insertRow().innerHTML = `<td colspan=${colCount}><div class="tblPagination"><center></center></div></td>`;

//   // if (numPages == 1) {
//   //   return;
//   // }

//   for (let i = 0; i < numPages; i++) {
//     let pageNum = i + 1;

//     table
//     .querySelector(".tblPagination center")
//     .insertAdjacentHTML(
//       "beforeend",
//       `<button class="btn btn-outline-primary" rel="${i}">${pageNum}</button> `
//     );
//   }

//   changeToPage(table, 1, rowsPerPage);

//   for (let tblPaginationA of table.querySelectorAll(".tblPagination button"))
//     tblPaginationA.addEventListener("click", (e) =>
//       changeToPage(table, parseInt(e.target.innerHTML), rowsPerPage)
//     );
// }

// const changeToPage = function (table, page, rowsPerPage) {
//   let startItem = (page - 1) * rowsPerPage;
//   let endItem = startItem + rowsPerPage;
//   let tblPaginationAs = table.querySelectorAll(".tblPagination button");
//   let tBodyRows = getBodyRows(table);

//   for (let nix = 0; nix < tblPaginationAs.length; nix++) {
//     if (nix == page - 1) {
//       tblPaginationAs[nix].classList.add("btn-outline-primary");
//       tblPaginationAs[nix].classList.remove("btn-outline-secondary");
//     } else {
//       tblPaginationAs[nix].classList.add("btn-outline-secondary");
//       tblPaginationAs[nix].classList.remove("btn-outline-primary");
//     }

//     for (let trix = 0; trix < tBodyRows.length; trix++) {
//       tBodyRows[trix].style.display =
//         trix >= startItem && trix < endItem ? "" : "none";
//     }
//   }
// }

// const getBodyRows = function (table) {
//   let initial = table.querySelectorAll("tbody tr");
//   console.log(initial.length)
//   if (initial.length == 0) {
//     initial = table.querySelectorAll("tb tr");
//     console.log(initial.length)
//   }
//   return Array.from(initial).filter(
//     (row) => row.querySelectorAll("td").length > 0
//   );
// }

// export { addPagerToTables, addPagerToTable, changeToPage, getBodyRows };

// // addPagerToTables("table", 6);
// // $(document).ready(function() {
// //     // addPagerToTables("table", 6);
// // });
// // Connect paignation script to following pages
// /*
//     * policy admin
//         * user list : Done
//         * policy list : Done
//     * assurance tasks (both task and people view) : Done
//     * risk register : issue with table
//     * asset register : issue with table
//     * user management : done
//     * report folder : working
// */


/*
 * Copyright (c) Secureroo PTY LTD 2022
 */

const addPagerToTables = function (tables, rowsPerPage = 10) {
  tables =
    typeof tables == "string" ? document.querySelectorAll(tables) : tables;

  for (let table of tables) {
    addPagerToTable(table, rowsPerPage);
  }
};

const addPagerToTable = function (table, rowsPerPage = 10) {
  let tBodyRows = getBodyRows(table);
  let numPages = Math.ceil(tBodyRows.length / rowsPerPage);

  // Store pagination data in the table's dataset
  table.dataset.numPages = numPages;
  table.dataset.rowsPerPage = rowsPerPage;

  table.querySelector("tfoot")?.remove();

  let colCount = [].slice
    .call(table.querySelector("tr").cells)
    .reduce((a, b) => a + parseInt(b.colSpan), 0);

  table
    .createTFoot()
    .insertRow().innerHTML = `<td colspan=${colCount}><div class="tblPagination"><center></center></div></td>`;

  // Initialize pagination
  changeToPage(table, 1);
};

const changeToPage = function (table, page) {
  let rowsPerPage = parseInt(table.dataset.rowsPerPage);
  let numPages = parseInt(table.dataset.numPages);
  let startItem = (page - 1) * rowsPerPage;
  let endItem = startItem + rowsPerPage;
  let tBodyRows = getBodyRows(table);

  // Show or hide the table rows based on the current page
  for (let trix = 0; trix < tBodyRows.length; trix++) {
    tBodyRows[trix].style.display =
      trix >= startItem && trix < endItem ? "" : "none";
  }

  // Update pagination controls
  updatePaginationControls(table, page);
};

const updatePaginationControls = function (
  table,
  currentPage,
  maxPagesToShow = 10
) {
  let numPages = parseInt(table.dataset.numPages);
  let paginationContainer = table.querySelector(".tblPagination center");
  paginationContainer.innerHTML = "";

  // Add << and < buttons
  paginationContainer.insertAdjacentHTML(
    "beforeend",
    `<button class="btn btn-outline-primary" data-page="first" style="border-color: transparent !important;"><i class="fa-duotone fa-solid fa-chevrons-left" style="color: #f6961d !important;"></i></button> ` +
    `<button class="btn btn-outline-primary" data-page="prev" style="border-color: transparent !important;"><i class="fa-duotone fa-solid fa-chevron-left" style="color: #f6961d !important;"></i></button> `
  );

  // Calculate start and end pages
  let half = Math.floor(maxPagesToShow / 2);
  let startPage = Math.max(
    1,
    currentPage - half + (maxPagesToShow % 2 === 0 ? 1 : 0)
  );
  let endPage = startPage + maxPagesToShow - 1;

  if (endPage > numPages) {
    endPage = numPages;
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  // Add page number buttons
  for (let i = startPage; i <= endPage; i++) {
    let activeClass =
      i === currentPage ? "btn-primary" : "btn-outline-secondary";
    paginationContainer.insertAdjacentHTML(
      "beforeend",
      `<button class="btn ${activeClass}" data-page="${i}">${i}</button> `
    );
  }

  // Add > and >> buttons
  paginationContainer.insertAdjacentHTML(
    "beforeend",
    `<button class="btn btn-outline-primary" data-page="next" style="border-color: transparent !important;"><i class="fa-duotone fa-solid fa-chevron-right" style="color: #f6961d !important;"></i></button> ` +
    `<button class="btn btn-outline-primary" data-page="last" style="border-color: transparent !important;"><i class="fa-duotone fa-solid fa-chevrons-right" style="color: #f6961d !important;"></i></button>`
  );

  // Add event listeners to the buttons
  let buttons = paginationContainer.querySelectorAll("button");
  for (let btn of buttons) {
    btn.addEventListener("click", (e) => {
      let targetPage = e.target.getAttribute("data-page");
      let currentPage = parseInt(table.dataset.currentPage) || 1;
      if (targetPage === "first") {
        changeToPage(table, 1);
      } else if (targetPage === "prev") {
        changeToPage(table, Math.max(1, currentPage - 1));
      } else if (targetPage === "next") {
        changeToPage(table, Math.min(numPages, currentPage + 1));
      } else if (targetPage === "last") {
        changeToPage(table, numPages);
      } else {
        changeToPage(table, parseInt(targetPage));
      }
    });
  }

  // Store current page
  table.dataset.currentPage = currentPage;
};

const getBodyRows = function (table) {
  let initial = table.querySelectorAll("tbody tr");
  if (initial.length == 0) {
    initial = table.querySelectorAll("tb tr");
  }
  return Array.from(initial).filter(
    (row) => row.querySelectorAll("td").length > 0
  );
};

export { addPagerToTables, addPagerToTable, changeToPage, getBodyRows };